import { toLocalDate } from '@pazportal/ui';

export function formatCurrency(cents: number): string {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
}

export function formatSolutionType(type: string): string {
  const labels: Record<string, string> = {
    managed_network: 'Managed Network Solutions', video_surveillance: 'Surveillance Solutions',
    access_control: 'Access Control', pro_av: 'Pro AV', digital_signage: 'Digital Signage',
    security_alarm: 'Security / Alarm', smart_robotics: 'Smart Robotics Solutions',
    keytracer: 'Security Solutions (KeyTracer)', it_cloud: 'IT & Cloud', pos_systems: 'Retail Solutions (POS)',
    conferencing: 'Conferencing Solutions', audio: 'Audio Solutions',
  };
  return labels[type] ?? type;
}

/**
 * A bare `YYYY-MM-DD` (a Postgres DATE such as `estimates.valid_until`) is a
 * calendar day, read as local midnight; parsing it with `new Date()` would make
 * it UTC midnight and show the day before across the US. Timestamps keep their
 * instant.
 */
export function formatDate(dateStr: string | null): string {
  const date = toLocalDate(dateStr);
  if (!date) return '\u2014';
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function timeAgo(dateStr: string): string {
  const date = toLocalDate(dateStr);
  if (!date) return '\u2014';
  const diffMs = Date.now() - date.getTime();
  const diffMin = Math.floor(diffMs / 60000);
  const diffHour = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHour / 24);
  if (diffMin < 1) return 'just now';
  if (diffMin < 60) return `${diffMin}m ago`;
  if (diffHour < 24) return `${diffHour}h ago`;
  if (diffDay < 30) return `${diffDay}d ago`;
  return date.toLocaleDateString();
}
